// extracted by mini-css-extract-plugin
module.exports = {"container":"part-breadcrumbs_container__oJ6OC","breadCrumbsContainer":"part-breadcrumbs_breadCrumbsContainer__5_lGL"};